import { render, staticRenderFns } from "./cordon-serrage.vue?vue&type=template&id=35ee652b&scoped=true"
import script from "./cordon-serrage.vue?vue&type=script&lang=js"
export * from "./cordon-serrage.vue?vue&type=script&lang=js"
import style0 from "./cordon-serrage.vue?vue&type=style&index=0&id=35ee652b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee652b",
  null
  
)

export default component.exports